import { SignUpParams } from '../api/interfaces';
import { Fields } from '../redux/slices/signUpSlice';

export const prepareSignUpData = (fields: Fields): SignUpParams => {
    return {
        phone: fields.phone,
        password: fields.password,
        agreeTerms: fields.agreeTerms,
        smsCode: fields.smsCode,
    };
};
